import { useEffect, useRef } from 'react';

import type { CodeString } from '@/consts/codes';
import { menu } from '@/consts/navigation';
import { useLocation } from 'react-router';

export const useTrackRecents = (addRecent: (code: CodeString | undefined) => Promise<void>) => {
  const location = useLocation();
  const lastCodeRef = useRef<string | null>(null);

  useEffect(() => {
    const allMenuItems = menu.flatMap((section) => section.children ?? []);
    const currentItem = allMenuItems.find((item) => item.to === location.pathname);

    if (!currentItem?.code) return;

    if (lastCodeRef.current === currentItem.code) return;
    lastCodeRef.current = currentItem.code;

    void addRecent(currentItem.code);
  }, [location.pathname, addRecent]);
};
